module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAAAAXNSR0IArs4c6QAAAKlJREFUOBGl1A0KgCAMBeDWlTxgdUDPZDxpoTjbmwniD72PCaNte0bO+cTUM7sKPkSwlHJgLyJXSunEnhnShjUQQXYNtSuqYZ8zPKGFmEoqgJD1FNx7yAusIh2wggxAFDGBCDIFWOQTYBAX8BCzExFih1uB12CfgBdGlVOACU8BNmwCkfAARMMdsBJ+gdVwBf6EAZid6P2FENRR+6CtIhJWpK5AMLtL4nADTHO6n/EDq9EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/new-wk-angle.png
// module id = 1957
// module chunks = 6